import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #000;
	padding: 20px;
	#back-button {
		display: inline-flex;
		width: 30px;
		height: 30px;
		img {
			width: 100%;
		}
	}
	#page-title {
		margin-top: 20px;
		font-weight: bold;
		font-size: 20px;
		color: #fff;
	}
	#transaction-presets {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-top: 20px;
		.preset-chip {
			padding: 8px 14px;
			border-radius: 20px;
			border: 1px solid #333;
			background: #111;
			color: #fff;
			font-size: 13px;
			font-weight: 500;
			cursor: pointer;
			transition: border-color 200ms ease, background 200ms ease;
			&:hover,
			&:active {
				border-color: #fff;
				background: #222;
			}
		}
	}
	#add-transaction-form {
		margin-top: 30px;
	}
	#add-transaction-button {
		background: #fff;
		color: #000;
	}
`;
